export const shippingUnitRecordStatus = [
  { key: "O", badgeColor: "success" },
  { key: "C", badgeColor: "danger" },
];

export const shippingUnitRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const shippingUnitModeList = {
  VIEW_SHIPPING_UNIT_DETAIL: "VIEW_SHIPPING_UNIT_DETAIL",
  EDIT_SHIPPING_UNIT_DETAIL: "EDIT_SHIPPING_UNIT_DETAIL",
};

export const getInitShippingUnitParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
  };
};
